import React from 'react';
import PublicHeader from './PublicHeader';
import Footer from './Footer';
import '../styles/layout.css';

const PublicLayout = ({ children }) => {
  return (
    <div className="layout">
      <PublicHeader />
      <div className="content">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default PublicLayout;